import { format } from 'date-fns'

import { DATE_FULL_FORMAT } from '../../../constants/date'
import { useUkTimeZone } from '../../../hooks'
import { toUkTimezoneDate } from '../../../utils/date'
import { Status } from '../../Status'

import { getEntityDeadlineStatusRequestColorProperties } from './EntityDeadlineStatus.utils'

function EntityDeadlineStatus({
  className,
  deadline,
  getColorProperties = getEntityDeadlineStatusRequestColorProperties,
  status,
}) {
  const { timezone } = useUkTimeZone()

  const ukDeadline = toUkTimezoneDate(deadline, timezone)

  return (
    <Status
      {...getColorProperties(ukDeadline, status)}
      className={className}
      text={format(ukDeadline, DATE_FULL_FORMAT)}
    />
  )
}

export default EntityDeadlineStatus
